function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HttpClient } from 'api/http-client';
class PhaseAPIClient extends HttpClient {
    async createDependentPhase(phaseId, data, isSync, toggleUpdating) {
        const resp = await this.post(`/phases/${phaseId}/add-dependency${isSync ? `?isSync=${true}` : ''}`, data);
        if (resp && toggleUpdating) {
            toggleUpdating(false);
        }
        return resp;
    }
    async removeDependentPhase(phaseId, data) {
        return this.post(`/phases/${phaseId}/remove-dependency`, data);
    }
    async updateDependentPhases(phaseId, data, isSync, toggleUpdating) {
        const resp = await this.post(`/phases/${phaseId}/update-dependent-phases${isSync ? `?isSync=${true}` : ''}`, data);
        if (resp && toggleUpdating) {
            toggleUpdating(false);
        }
        return resp;
    }
    constructor(...args){
        super(...args), _define_property(this, "updateEntityOrder", (phaseId, payload)=>{
            return this.put(`/phases/${phaseId}/update-entity-order`, payload);
        }), _define_property(this, "getProjectPhase", (phaseId)=>{
            return this.get(`/phases/${phaseId}`);
        });
    }
}
export const PhaseAPI = new PhaseAPIClient();
